import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const slideUD = (element, delay = 0) => {
  gsap.fromTo(
    element,
    {
      y: -50,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      duration: 2,
      ease: "power3.out",
      stagger: 0.2,
      delay,
    }
  );
};

gsap.registerPlugin(ScrollTrigger);

export const fadeWordsOnScroll = (selector) => {
  const words = document.querySelectorAll(`${selector} .word`);
  gsap.to(words, {
    y: 0,
    opacity: 1,
    duration: 0.5,
    ease: "power3.out",
    stagger: 0.04,
    scrollTrigger: {
      trigger: selector,
      start: "top 80%",
      toggleActions: "play none none none",
    },
  });
};

export const scrolldownani = (element) => {
  gsap.fromTo(
    element,
    {
      y: 40,
      x:30,
      opacity: 0,
    },
    {
      y: 0,
      x:0,
      opacity: 1,
      duration: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: element,
        start: "top 85%",
        toggleActions: "play none none reverse",
        
      },
    }
  );
};